import { HomePageWithLandingProps } from '@features/user/home/types';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import businessConfig from '../../config/business';
import snappStoreLogo from '../../public/img/snapp-store.png';
import storageUtil from '../../utils/storageUtil';
import { safeString } from '../../utils/stringUtil';

const LandingLayout = ({ vendor }: HomePageWithLandingProps) => {
  const router = useRouter();
  return (
    <>
      <Head>
        <meta name="description" content={safeString(vendor?.subDomain)} />
        <meta name="application-name" content={safeString(vendor?.subDomain)} />
        <meta name="apple-mobile-web-app-title" content={safeString(vendor?.subDomain)} />
        <meta name="twitter:card" content={safeString(vendor?.subDomain)} />
        <meta name="twitter:url" content={`https://${safeString(vendor?.subDomain)}.${businessConfig.domain}`} />
        <meta name="twitter:title" content={safeString(vendor?.name)} />
        <meta name="twitter:description" content={safeString(vendor?.subDomain)} />
        <meta
          name="twitter:image"
          content={`https://${safeString(vendor?.subDomain)}.${businessConfig.domain}/android-chrome-192x192.png`}
        />
        <meta property="og:title" content={safeString(vendor?.subDomain)} />
        <meta property="og:description" content={safeString(vendor?.subDomain)} />
        <meta property="og:site_name" content={safeString(vendor?.name)} />
        <meta property="og:url" content={`https://${safeString(vendor?.subDomain)}.${businessConfig.domain}`} />
        <meta
          property="og:image"
          content={`https://${safeString(vendor?.subDomain)}.${businessConfig.domain}/apple-touch-icon.png`}
        />
      </Head>

      <div className="container grid my-8 mx-auto p-4 gap-y-4 max-w-5xl">
        <div className="relative w-full aspect-5/2 mx-auto">
          <Image
            className="block rounded-md object-cover"
            src={storageUtil.getLandingImage(safeString(vendor?.landing?.banner))}
            fill
            alt="banner"
          />
        </div>

        {vendor?.landing?.vendors?.map((item) => (
          <Link
            key={item.id}
            href={{
              pathname: `https://${item.customDomain || `${item?.subDomain}.${businessConfig.domain}`}/menu`,
              query: { ...router.query },
            }}
            className="h-20 shadow-lg px-4 flex justify-between rounded-md bg-white"
            target="_blank"
          >
            <div className="flex flex-col justify-center text-sm">{item.name}</div>
            <div className="relative h-16 my-2 aspect-square">
              <Image
                className="object-contain rounded-md"
                alt={safeString(item?.subDomain)}
                src={storageUtil.getItemImage(safeString(item?.subDomain), safeString(item.logo))}
                fill
              />
            </div>
          </Link>
        ))}

        <div className="flex mt-12 mx-auto h-10">
          <div className="relative h-full aspect-square">
            <Image className="object-contain rounded-sm" alt="snapp-store logo" src={snappStoreLogo} />
          </div>
          <div className="flex flex-col justify-center h-full px-2">powered by</div>
        </div>
      </div>
    </>
  );
};

export default LandingLayout;
